const REPORT_SETPLANTWITHOUTSTATINSPCHARTDATA = (state, data) => {
  state.plantWithoutStatInspChartData = {
    total: data.total,
    data: {
      series: [data.withoutStatInspCount, data.withStatInspCount]
    }
  };
};

const REPORT_SETTIMEDDEFECTSTATUSESCHARTDATA = (state, data) => {
  state.timedDefectStatusesChartData = {
    total: data.total,
    data: {
      series: [
        data.outstanding,
        0,
        data.complete,
        data.quoted,
        data.queried,
        data.resolved,
        data.frustrated
      ]
    }
  };
};

const REPORT_SETUNTIMEDDEFECTSTATUSESCHARTDATA = (state, data) => {
  state.untimedDefectStatusesChartData = {
    total: data.total,
    data: {
      series: [
        data.outstanding,
        0,
        data.complete,
        data.quoted,
        data.queried,
        data.resolved,
        data.frustrated
      ]
    }
  };
};

const REPORT_SETSAFEDSTATUSESCHARTDATA = (state, data) => {
  state.safedStatusesChartData = {
    total: data.total,
    data: {
      series: [
        data.outstanding,
        0,
        data.complete,
        data.quoted,
        data.queried,
        data.resolved,
        data.frustrated
      ]
    }
  };
};

const REPORT_SETSTATINSPSTATUSESCHARTDATA = (state, data) => {
  state.statInspStatusesChartData = {
    total: data.total,
    data: {
      series: [data.overdue, data.active, data.expired]
    }
  };
};

const set_quote_metric = (state, data) => {
  state.quoteMetric = data;
};

export default {
  REPORT_SETPLANTWITHOUTSTATINSPCHARTDATA,
  REPORT_SETTIMEDDEFECTSTATUSESCHARTDATA,
  REPORT_SETUNTIMEDDEFECTSTATUSESCHARTDATA,
  REPORT_SETSAFEDSTATUSESCHARTDATA,
  REPORT_SETSTATINSPSTATUSESCHARTDATA,
  set_quote_metric
};
